import React, { useState } from 'react';
import { IOrder, ISearchOrderReq, ISearchOrderRes } from '@/interfaces/order';
import { DatePicker, Input, Select, TablePaginationConfig } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { searchOrders } from '@/adapters/order';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import locale from 'antd/es/date-picker/locale/th_TH';
import dayjs, { Dayjs } from 'dayjs';
import OrderTable from './components/order-table';
import Card from '@/components/card';
import { getOrderStatusOptions } from '@/helpers/orderHelper';
import { AxiosResponse } from 'axios';

const { Search } = Input;

const _criteria: ISearchOrderReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: 10,
  pageStart: 1,
  search: '',
  include: true,
  startDate: dayjs().toDate(),
  endDate: dayjs().toDate(),
};

const DashboardOrder = () => {
  const [criteria, setCriteria] = useState<ISearchOrderReq>({
    ..._criteria,
  });

  const { data, isLoading } = useQuery<AxiosResponse<ISearchOrderRes>, Error>({
    queryKey: ['search-media', criteria],
    queryFn: async () => await searchOrders(criteria),
    enabled: !!criteria,
  });

  const onTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<IOrder> | SorterResult<IOrder>[],
  ) => {
    const newCriteria = { ...criteria };
    if (!Array.isArray(sorter)) {
      newCriteria.orderBy = (sorter.column?.dataIndex as keyof IOrder) || '';
      newCriteria.orderType = sorter.order || '';
    }
    setCriteria({
      ...newCriteria,
      pageStart: Number(pagination.current || 1),
      pageSize: Number(pagination.pageSize || 10),
    });
  };

  const onSearch = (text: string) => {
    setCriteria({
      ...criteria,
      search: text,
      orderBy: 'id',
      orderType: '',
      pageStart: 1,
      pageSize: 10,
    });
  };

  const onRangeChange = (dates: null | (Dayjs | null)[]) => {
    if (dates) {
      setCriteria({
        ...criteria,
        orderBy: 'id',
        orderType: '',
        pageStart: 1,
        pageSize: 10,
        startDate: dates[0]?.toDate(),
        endDate: dates[1]?.toDate(),
      });
    } else {
      setCriteria({
        ...criteria,
        orderBy: 'id',
        orderType: '',
        pageStart: 1,
        pageSize: 10,
        startDate: null,
        endDate: null,
      });
    }
  };
  return (
    <Card customClass="flex flex-col drop-shadow-none p-4 gap-2">
      <div className="flex md:flex-row flex-col md:justify-between items-center gap-3">
        <h2 className="text-xl font-bold text-black">ออเดอร์</h2>
        <div className="flex flex-col md:flex-row justify-between gap-3">
          <div className="flex flex-col md:flex-row justify-between gap-3">
            <DatePicker.RangePicker
              size="large"
              locale={locale}
              onChange={onRangeChange}
              defaultValue={[
                dayjs(criteria?.startDate as string),
                dayjs(criteria?.endDate as string),
              ]}
            />
            <Select
              allowClear
              className="md:min-w-[150px]"
              size="large"
              placeholder="เลือก สถานะ"
              options={getOrderStatusOptions()}
              value={criteria?.status}
              onChange={e =>
                setCriteria({
                  ...criteria,
                  status: e,
                })
              }
            />
            <Search
              className="md:max-w-[400px] md:min-w-[400px]"
              placeholder="ค้นหา"
              allowClear
              size="large"
              enterButton="ค้นหา"
              onSearch={onSearch}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <OrderTable
          criteria={criteria}
          order={data?.data || { data: [], totalRecords: 0 }}
          loading={isLoading}
          onEditData={item => console.log(item)}
          onTableChange={onTableChange}
        />
      </div>
    </Card>
  );
};

export default DashboardOrder;
